import { Navigate } from "react-router-dom";
import NotFound from "../Pages/NotFound";
import Supplier from "../Pages/Supplier";
// import Notifications from "../Pages/Notifications";
import MyMembers from "../Pages/MyMembers";
import MySuppliers from "../Pages/MySuppliers";
import CommunitySettings from "../Pages/CommunitySettings";
import FindCommunities from "../Pages/FindCommunities";
import MyCommunities from "../Pages/MyCommunities";
import ManagePricelists from "../Pages/ManagePricelists";
import BusinessSettings from "../Pages/BusinessSettings";
import MyJobs from "../Pages/MyJobs";
import Dashboard from "../Pages/Dashboard";
import GrowCommunity from "../Pages/GrowCommunity";
import CommunitiesOverview from "../Pages/CommunitiesOverview";
import ManagersHubPage from "../Pages/ManagersHub";

export const supplierRoutes = [
  {
    path: "/",
    element: <Navigate to="/my-communities" replace />,
    hideTitle: true,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    title: "dashboard_supplier",
    hideTitle: true,
  },
  {
    path: "/find-communities",
    element: <FindCommunities />,
    title: "find_communities",
  },
  {
    path: "/my-communities",
    element: <MyCommunities />,
    title: "communities_management",
  },
  {
    path: "/manage-pricelists",
    element: <ManagePricelists />,
    title: "price_lists",
  },
  {
    path: "/my-jobs",
    element: <MyJobs />,
    title: "my_jobs",
  },
  {
    path: "/business-settings",
    element: <BusinessSettings />,
    title: "business_settings",
  },
];

export const communityRoutes = [
  {
    path: "/",
    element: <Navigate to="/my-suppliers" replace />,
    hideTitle: true,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    title: "dashboard_community",
    hideTitle: true,
  },
  {
    // FE-first mock — Grow your community (weekly tasks, share grid, reply helper).
    path: "/grow-community",
    element: <GrowCommunity />,
    title: "grow_community",
  },
  {
    path: "/communities",
    element: <CommunitiesOverview />,
    title: "my_communities",
    // Show the title in the mobile top bar (like other pages) but not as a
    // desktop heading — the desktop page is intentionally title-less.
    hideTitle: false,
    mobileTitleOnly: true,
  },
  {
    // Manager-of-Managers hub — sits right below the multi-community dashboard.
    path: "/managers-hub",
    element: <ManagersHubPage />,
    title: "managers_hub",
  },
  {
    path: "/find-suppliers",
    element: <Supplier />,
    title: "find_suppliers",
  },
  {
    path: "/my-suppliers",
    element: <MySuppliers />,
    title: "community_suppliers",
  },
  {
    path: "/my-members",
    element: <MyMembers />,
    title: "community_members",
  },
  {
    path: "/community-settings",
    element: <CommunitySettings />,
    title: "community_settings",
  },
];

export const sharedRoutes = [
  {
    path: "*",
    element: <NotFound />,
    hideTitle: true,
  },
];
